import {Component, Input} from '@angular/core';
import {ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule} from "@clr/angular";
import {RouterLink} from "@angular/router";
import {DatePipe, NgIf} from "@angular/common";
import {Delivery, StatusButtons} from "../../../_shared/interfaces";
import {TransportStoreService} from "../../../_shared/services";
import {
  checkCircleIcon,
  ClarityIcons,
  exclamationCircleIcon,
  exclamationTriangleIcon,
  infoCircleIcon
} from "@cds/core/icon";

@Component({
  selector: 'app-order-transport',
  standalone: true,
  imports: [
    ClrDatagridModule,
    ClrIconModule,
    RouterLink,
    DatePipe,
    NgIf
  ],
  templateUrl: './order-transport.component.html',
  styleUrl: './order-transport.component.sass'
})
export class OrderTransportComponent {
  transport: Delivery[] = []
  statusLabel = 'label-light-blue';
  statusText = '';
  public loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  @Input() projectId: string = '';
  @Input() jobId: number = 0;
  @Input() orderId: number = 0;

  statusButtons: StatusButtons[] = [
    { state: 'running', display: 'In Arbeit', label: 'alert-info', icon: 'info-circle'},
    { state: 'onhold', display: 'Wartet auf Abholung', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'ontour', display: 'On Tour', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'done', display: 'Empfang bestätigt', label: 'alert-success', icon: 'check-circle'}
  ];

  constructor(
    private transss: TransportStoreService,
  ) {
    ClarityIcons.addIcons(infoCircleIcon, checkCircleIcon, exclamationCircleIcon, exclamationTriangleIcon)
  }

  ngOnInit(): void {

    this.loadList();
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    const idx = buttons.findIndex(el => el.state === projectstatus);
    return idx >= 0 ? idx : 0;
  };

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus) + " alert-sm";
  }

  getCellStatus(invoicestatus: string) {
    const statusline = this.findButtonStatus(invoicestatus, this.statusButtons);
    return this.statusButtons[statusline].label;
  }

  loadList() {
    this.transss.getTransport(this.projectId, this.orderId, 0, 'all').subscribe({
      next: data => {
        this.transport = data.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        return;
      }
    });
  }
}
